import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-da51a7e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_wrap" }
const _hoisted_2 = { class: "mod_c_title" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "among_about flex" }
const _hoisted_5 = { class: "among" }
const _hoisted_6 = { class: "flex among_type" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "among_type_tit" }, "用户词库：", -1))
const _hoisted_8 = { class: "flex among_type_words" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "among_type_right"
}
const _hoisted_11 = { class: "among_box" }
const _hoisted_12 = { class: "above flex" }
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = { class: "flex" }
const _hoisted_15 = { class: "among_hear flex" }
const _hoisted_16 = { class: "flex" }
const _hoisted_17 = { class: "flex" }
const _hoisted_18 = { class: "flex" }
const _hoisted_19 = { class: "" }
const _hoisted_20 = {
  key: 0,
  class: "mod_pagin"
}
const _hoisted_21 = { class: "flex modal_add" }
const _hoisted_22 = { class: "flex modal_add" }

import Crumb from '@/components/Crumb.vue';
import CDelModal from '@/components/CDelModal.vue';
import { ref, reactive, computed, unref, onMounted, onBeforeMount } from 'vue';
import { useRoute } from 'vue-router';
import { Input, Checkbox, Modal, message, Upload, Switch, Table, Pagination, Tooltip } from 'ant-design-vue';
import { SearchOutlined, EditOutlined } from '@ant-design/icons-vue';
import { emptyDataSec } from '@/assets';
import http from '@/api';
import { WordsType, RootModal, WordsList, FileItem, FileInfo, UserWordsList } from './sensitive';
import { getToken } from '@/plugins/cookie';
import { Key } from 'ant-design-vue/lib/_util/type';


export default /*#__PURE__*/_defineComponent({
  __name: 'Sensitive',
  setup(__props) {

const route = useRoute();
const token = getToken();
const aInputSearch = Input.Search;
const aCheckbox = Checkbox;
const aModal = Modal;
const aUpload = Upload;
const aSwitch = Switch;
const aTable = Table;
const aPagination = Pagination;
const aTooltip = Tooltip;
// 获取用户词库列表
const userWordList = ref<UserWordsList[]>([]);
const getUserWordFirst = async () => {
  try {
    const res = await http.sensitive.getUserList();
    userWordList.value = res.data.data;
    woerdsId.value = userWordList.value[0].id;
    woerdsName.value = userWordList.value[0].thesaurus_name;
    getWords();
  } catch (err) {
    console.error(err);
  }
};
getUserWordFirst();

const getUserWords = async () => {
  try {
    const res = await http.sensitive.getUserList();
    userWordList.value = res.data.data;
    getWords();
  } catch (err) {
    console.error(err);
  }
};
const woerdsId = ref(); //用户词库id
const woerdsName = ref('');
const clickUserWord = (index: number) => {
  woerdsId.value = userWordList.value[index].id;
  woerdsName.value = userWordList.value[index].thesaurus_name;
  getWords();
};

const userWordName = ref('');
const addUserModal = ref(false);
const keyUserModal = ref();
const openUserModal = (key: number, item?: any) => {
  //0 添加  1修改  2删除用户词库
  switch (key) {
    case 0:
      addUserModal.value = !addUserModal.value;
      keyUserModal.value = key;
      userWordName.value = '';
      break;
    case 1:
      addUserModal.value = !addUserModal.value;
      keyUserModal.value = key;
      item ? (userWordName.value = item.thesaurus_name) : '';
      break;
    case 2:
      delWordModal.value = !delWordModal.value;
      keyUserModal.value = key;
  }
};

// 修改、添加用户词库
const setUserWords = () => {
  const data = { id: keyUserModal.value ? woerdsId.value : '', thesaurus_name: userWordName.value, set_type: keyUserModal.value };
  http.sensitive
    .setDefaultList(data)
    .then((res) => {
      message.success(res.data.message);
      addUserModal.value = false;
      getUserWords();
    })
    .catch((err) => message.error(err.data.error));
};

// 删除用户词库
const delWordModal = ref(false);
const delUserWord = () => {
  console.log(woerdsId.value);
  http.sensitive
    .delWordsState({ params: { id: woerdsId.value } })
    .then((res) => {
      message.success(res.data.message);
      delWordModal.value = false;
      getUserWords();
      woerdsId.value = userWordList.value[0].id;
    })
    .catch((err) => message.error(err.data.error));
};

//搜索
const query = ref<string>('');
const onChangeList = () => {
  getWords();
};

const columns = [
  { title: 'id', dataIndex: 'id', key: 'id', width: 80 },
  { title: '敏感词', dataIndex: 'sensitive_word', key: 'sensitive_word' },
  { title: '操作', dataIndex: 'state', key: 'state', width: 180, align: 'right', slots: { customRender: 'state' } },
];

const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 10, // 每页条数
  totalSize: 0, // 总页数
  options: ['10', '24', '36', '48', '60'], // 选项
  size: 'small', // 尺寸
  showJumper: false, // 是否显示跳页
  showSize: false, // 是否显示条数切换
});
//获取敏感词列表
const wordsData = ref<WordsType[]>([]);
const getWords = () => {
  const data = {
    keywords: query.value,
    thesaurus_id: woerdsId.value,
    page: pageConfig.current,
    page_num: pageConfig.pageSize,
  };
  http.sensitive
    .getSensitiveWords({ params: data })
    .then((res) => {
      const resData = JSON.parse(JSON.stringify(res.data.data.data));
      wordsData.value = resData;
      pageConfig.current = res.data.data.current_page;
      pageConfig.totalSize = res.data.data.total;
      choiceBan.value = res.data.data.status ? true : false;
    })
    .catch((err) => {
      console.error(err.data.error);
    });
};

//添加、修改敏感词
const createVeiw = ref<boolean>(false); //添加
const index = ref<number>(0);
const updataWords = ref<string>(''); //敏感词
const wordId = ref<string>(''); //修改单词id

const showModal = (key: number, item?: any) => {
  //  0敏感词添加  1敏感词修改   2/3 敏感多项选删除/单项删除 二级确认
  switch (key) {
    case 0:
      createVeiw.value = !createVeiw.value;
      index.value = key;
      updataWords.value = '';
      break;
    case 1:
      createVeiw.value = !createVeiw.value;
      index.value = key;
      wordId.value = item?.id;
      updataWords.value = item?.sensitive_word;
      break;
    case 2:
      delModal.visibleAll = !delModal.visibleAll;
      index.value = key;
      break;
    case 3:
      delModal.visibleOnly = !delModal.visibleOnly;
      index.value = key;
      wordId.value = item?.id;
      break;
  }
};

const selectedRowKeys = ref<Key[]>([]);
const onSelectChange = (changableRowKeys: Key[]) => {
  selectedRowKeys.value = changableRowKeys;
  choiceCheck.value = selectedRowKeys.value.length === wordsData.value.length ? true : false;
};
const getSelected = computed(() => selectedRowKeys.value.length === 0);
const choiceCheck = ref<boolean>(false); //全选
const changeAllKey = () => {
  if (choiceCheck.value) selectedRowKeys.value = wordsData.value.map((e) => e.id);
  else selectedRowKeys.value = [];
};

// 删除
const delModal = reactive<RootModal>({
  title: '提示',
  visibleAll: false,
  visibleOnly: false,
});

// 删除敏感词
const deleteWords = () => {
  const ids = ref();
  if (index.value === 3) {
    ids.value = wordId.value; //删除单个
  } else {
    ids.value = selectedRowKeys.value.join(',');
  }
  http.sensitive
    .delSensitiveWords({ id: ids.value })
    .then((res) => {
      message.success(res.data.message);
      index.value === 3 ? showModal(3) : showModal(2);
      choiceCheck.value = false;
      selectedRowKeys.value = [];
      getWords();
    })
    .catch((err) => {
      message.error(err.data.error);
    });
};

// 设置敏感词添加修改
const setWords = () => {
  const data = {
    sensitive_word: updataWords.value,
    set_type: index.value, //0.添加；1.修改更新
    id: index.value ? wordId.value : '',
    thesaurus_id: woerdsId.value,
  };
  http.sensitive
    .setSensitiveWords(data)
    .then((res) => {
      message.success(res.data.message);
      showModal(index.value);
      getWords();
    })
    .catch((err) => {
      message.error(err.data.error);
    });
};

// 设置敏感词状态
const choiceBan = ref(false);
const setWordsState = (item?: any) => {
  let data = {};
  if (item.id) {
    data = { status: item.status === 1 ? 0 : 1, id: item.id, type: 0 };
  } else {
    data = { status: choiceBan.value ? 1 : 0, type: 1, thesaurus_id: woerdsId.value };
  }
  http.sensitive
    .setWordsState(data)
    .then((res) => {
      message.success(res.data.message);
      getWords();
    })
    .catch((err) => message.error(err.data.error));
};

// 公共词库
const initialList = ref<WordsList[]>([]);
const getDefaultList = async () => {
  try {
    const res = await http.sensitive.getDefaultList();
    initialList.value = res.data.data;
  } catch (err) {
    console.error(err);
  }
};
getDefaultList();

const fileList = ref<FileItem[]>([]);
const handleChange = (info: FileInfo) => {
  if (info.file.status === 'done') {
    if (info.file?.response?.code === 200) {
      message.success(info.file?.response?.message);
      getWords();
    }
    if (info.file?.response?.code === 100) {
      message.error(info.file?.response?.error);
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Crumb),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(route).meta.title), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createTextVNode(" 公共词库：   "),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(initialList.value, (e) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "among_about_box",
              key: e.id
            }, _toDisplayString(e.type_name), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userWordList.value, (word, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["among_type_box flex", { among_type_action: woerdsId.value === word.id }]),
                  key: word.id,
                  onClick: ($event: any) => (clickUserWord(index))
                }, [
                  _createTextVNode(_toDisplayString(word.thesaurus_name) + " ", 1),
                  (woerdsId.value === word.id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_component_a_button, {
                          type: "link",
                          class: "among_type_but",
                          onClick: ($event: any) => (openUserModal(1, word))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_svg_icon, { "icon-class": "sensitive_action_set" })
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        (userWordList.value.length > 1)
                          ? (_openBlock(), _createBlock(_component_a_button, {
                              key: 0,
                              type: "link",
                              class: "among_type_but",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (openUserModal(2)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_svg_icon, { "icon-class": "sensitive_action_del" })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_9))
              }), 128)),
              _createVNode(_component_a_button, {
                type: "link",
                class: "among_create",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (openUserModal(0)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, { "icon-class": "sensitive_action_create" })
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  class: "above_but gap",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (showModal(0)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("添加敏感词")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(aInputSearch), {
                  class: "mod_range_picker_search gap",
                  value: query.value,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((query).value = $event)),
                  placeholder: "搜索：关键字",
                  onSearch: onChangeList
                }, {
                  enterButton: _withCtx(() => [
                    _createVNode(_unref(SearchOutlined))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_a_button, {
                  type: "link",
                  class: "dow gap",
                  href: "https://images.innocomn.com/0204c202205251026147504.xlsx"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 下载Excal模板 ")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(aUpload), {
                  "file-list": fileList.value,
                  "onUpdate:fileList": _cache[4] || (_cache[4] = ($event: any) => ((fileList).value = $event)),
                  action: "/api/v1/account/import_sensitive_words",
                  showUploadList: false,
                  accept: ".xlsx,.xls,.csv",
                  headers: { token: _unref(token) },
                  data: { type: 0, thesaurus_id: woerdsId.value },
                  onChange: handleChange,
                  multiple: true,
                  name: "excel"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      class: "above_but gap"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("批量导入")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["file-list", "headers", "data"])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", null, _toDisplayString(woerdsName.value), 1),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_unref(aSwitch), {
                    checked: choiceBan.value,
                    "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((choiceBan).value = $event)),
                    size: "small",
                    onChange: setWordsState,
                    disabled: wordsData.value.length === 0
                  }, null, 8, ["checked", "disabled"]),
                  _createTextVNode("  全部禁用/启用   ")
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_unref(aCheckbox), {
                    checked: choiceCheck.value,
                    "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => ((choiceCheck).value = $event)),
                    onChange: changeAllKey,
                    disabled: wordsData.value.length === 0
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("全选")
                    ]),
                    _: 1
                  }, 8, ["checked", "disabled"])
                ]),
                _createVNode(_component_a_button, {
                  class: "mod_btn",
                  type: "link",
                  danger: "",
                  disabled: _unref(getSelected),
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (showModal(2)))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_svg_icon, {
                      class: "mod_btn_icon",
                      "icon-class": "del"
                    })
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode("删除 ")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_unref(aTable), {
                class: "ant-table-striped",
                columns: columns,
                "data-source": wordsData.value,
                "row-selection": { selectedRowKeys: selectedRowKeys.value, onChange: onSelectChange },
                pagination: false,
                showHeader: false,
                rowClassName: (record) => (record.status ? '' : 'table-striped'),
                "row-key": "id",
                size: "small"
              }, {
                state: _withCtx(({ record }) => [
                  _createVNode(_unref(aTooltip), null, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(record.status === 1 ? '禁用' : '启用'), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (setWordsState(record))
                      }, {
                        default: _withCtx(() => [
                          (record.status === 1)
                            ? (_openBlock(), _createBlock(_component_svg_icon, {
                                key: 0,
                                "icon-class": "sensitive_ban"
                              }))
                            : (_openBlock(), _createBlock(_component_svg_icon, {
                                key: 1,
                                "icon-class": "sensitive_pass"
                              }))
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_unref(aTooltip), null, {
                    title: _withCtx(() => [
                      _createTextVNode("修改")
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (showModal(1, record))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_svg_icon, { "icon-class": "sensitive_updata" })
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_unref(aTooltip), null, {
                    title: _withCtx(() => [
                      _createTextVNode("删除")
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (showModal(3, record))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_svg_icon, { "icon-class": "sensitive_del" })
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 8, ["data-source", "row-selection", "rowClassName"])
            ]),
            (wordsData.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createVNode(_unref(aPagination), {
                    "show-quick-jumper": "",
                    total: pageConfig.totalSize,
                    current: pageConfig.current,
                    "onUpdate:current": _cache[8] || (_cache[8] = ($event: any) => ((pageConfig.current) = $event)),
                    "page-size": pageConfig.pageSize,
                    "onUpdate:pageSize": _cache[9] || (_cache[9] = ($event: any) => ((pageConfig.pageSize) = $event)),
                    pageSizeOptions: pageConfig.options,
                    "show-less-items": "",
                    "show-size-changer": "",
                    onChange: getWords,
                    onShowSizeChange: getWords
                  }, null, 8, ["total", "current", "page-size", "pageSizeOptions"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createVNode(_unref(aModal), {
        visible: createVeiw.value,
        "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((createVeiw).value = $event)),
        width: 450,
        centered: "",
        title: index.value === 0 ? '添加' : '修改',
        onOk: setWords
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_21, [
            _createTextVNode(" 敏感词： "),
            _createVNode(_component_a_input, {
              value: updataWords.value,
              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((updataWords).value = $event)),
              maxlength: 10,
              class: "modal_text",
              placeholder: ""
            }, {
              suffix: _withCtx(() => [
                _createTextVNode(_toDisplayString(updataWords.value.length) + " / 10 ", 1)
              ]),
              _: 1
            }, 8, ["value"])
          ])
        ]),
        _: 1
      }, 8, ["visible", "title"]),
      _createVNode(CDelModal, {
        visible: delModal.visibleAll,
        centered: "",
        close: () => showModal(2),
        ok: deleteWords
      }, null, 8, ["visible", "close"]),
      _createVNode(CDelModal, {
        visible: delModal.visibleOnly,
        centered: "",
        close: () => showModal(3),
        ok: deleteWords
      }, null, 8, ["visible", "close"]),
      _createVNode(_unref(aModal), {
        visible: addUserModal.value,
        "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((addUserModal).value = $event)),
        width: 450,
        centered: "",
        title: keyUserModal.value === 0 ? '添加' : '修改',
        onOk: setUserWords
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_22, [
            _createTextVNode(" 词库名称： "),
            _createVNode(_component_a_input, {
              value: userWordName.value,
              "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((userWordName).value = $event)),
              maxlength: 10,
              class: "modal_text",
              placeholder: ""
            }, null, 8, ["value"])
          ])
        ]),
        _: 1
      }, 8, ["visible", "title"]),
      _createVNode(CDelModal, {
        visible: delWordModal.value,
        centered: "",
        close: () => openUserModal(2),
        ok: delUserWord
      }, null, 8, ["visible", "close"])
    ])
  ], 64))
}
}

})